<template>
  <div>
    <vs-popup title="Detalle" :active.sync="modal_data_query">
      <div
        class="grid grid-cols-1 lg:grid-cols-4 gap-2 py-2 justify-center items-center"
        style="
          font-size: 1.8vh !important;
          border-bottom: 1px solid rgb(227, 227, 227);
        "
        v-for="([key, value], index) in detal_selectedArray"
        :key="index"
      >
        <div class="lg:col-span-2">
          <b>{{ key }}: </b>
        </div>
        <div class="lg:col-span-2">
          {{ typeof value === "string" ? value.replace(/\|/g, ",") : value }}
        </div>
      </div>
    </vs-popup>

    <vs-popup title="Cargar archivo" :active.sync="modal_upload">
      <div class="text-warning mb-5">
        <span
          style="cursor: pointer; text-decoration: underline"
          @click="download_format()"
          >Clíc aqui para descargar formato csv</span
        >
      </div>

      <input
        type="file"
        id="file_client"
        accept=".csv"
        class="input_file_client mb-10"
      />
      <div align="center">
        <vs-button
          style="margin: auto; width: 100%"
          @click="upload_file()"
          v-if="!uploading"
          >Subir</vs-button
        >
        <vs-progress indeterminate color="primary" v-else></vs-progress>
      </div>
    </vs-popup>

    <vs-popup
      :title="'Notas cliente: ' + client_selected.currentOwnerName"
      :active.sync="notes_modal"
    >
      <div class="leading-1">
        {{ client_selected.gcc_note }} -
        <span class="text-sm font-bold">
          Asignado por {{ client_selected.gcc_admin_name }}
        </span>
      </div>

      <div class="my-6" v-for="(item, index) in notes" :key="index">
        <div class="shadow px-4 py-2 rounded bg-[#c8dbf4]">
          <div class="mb-2">{{ item.gnc_note }}</div>
          <div class="flex justify-between text-sm">
            <span>{{ item.gestor_name }}</span>
            <span>{{ item.gnc_created_at.date.substring(0, 16) }}</span>
          </div>
        </div>
      </div>

      <div class="gap-4">
        <vs-divider></vs-divider>
        <vs-textarea v-model="note_client"></vs-textarea>
        <vs-button @click="save_note">Enviar nota</vs-button>
      </div>
    </vs-popup>

    <div class="table_header_sm" style="display: none">
      <div
        style="
          display: flex;
          gap: 20px;
          justify-content: center;
          align-items: center;
        "
      >
        <div>
          <vs-button color="success" class="mb-3 p-2" @click="exportToXLSX"
            >Exportar a XLSX</vs-button
          >
          <vs-button color="danger" class="mb-3 p-2" @click="exportToPDF"
            >Exportar a PDF&nbsp;</vs-button
          >
          <!-- <vx-tooltip text="Cargue un archivo csv con los valores por cada cliente mupa">
                        <vs-button @click="modal_upload = true" size="small" radius color="primary" type="border" icon-pack="feather" icon="icon-upload"></vs-button>
                    </vx-tooltip> -->
        </div>

        <div class="text-center">
          <span>Mostrar</span>
          <select class="select_pagination" sty v-model="items_table">
            <option selected value="5">5</option>
            <option value="10">10</option>
            <option value="25">25</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </select>
        </div>
      </div>
    </div>

    <vs-table
      stripe
      pagination
      :max-items="items_table"
      search
      :data="data_query"
    >
      <template slot="header">
        <div style="width: 100%; display: flex; justify-content: space-between">
          <div style="display: flex; align-items: center; gap: 10px">
            <div
              class="mr-2"
              v-if="data_query"
              style="font-weight: 700; font-size: 2.3vh"
            >
              Saldo total: <span style="color: orange">{{ total }}</span>
            </div>
            <vs-button
              class="table_header_lg p-2"
              color="success"
              @click="exportToXLSX"
              >Exportar a XLSX</vs-button
            >
            <vs-button
              class="table_header_lg p-2"
              color="danger"
              @click="exportToPDF"
              >Exportar a PDF</vs-button
            >

            <!-- <vx-tooltip class="table_header_lg" text="Cargue un archivo csv con los valores por cada cliente mupa">
                            <vs-button @click="modal_upload = true" size="small" radius color="primary" type="border" icon-pack="feather" icon="icon-upload"></vs-button>
                        </vx-tooltip> -->
          </div>

          <div class="table_header_lg">
            <span>Mostrar</span>
            <select class="select_pagination" sty v-model="items_table">
              <option selected value="5">5</option>
              <option value="10">10</option>
              <option value="25">25</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </select>
          </div>
        </div>
      </template>

      <template slot="thead">
        <vs-th>Ver</vs-th>
        <vs-th> Notas </vs-th>
        <vs-th sort-key="segmentation">Segmentación</vs-th>
        <vs-th sort-key="valorTotal_float">Valor Total</vs-th>
        <vs-th sort-key="panapass">Panapass</vs-th>
        <vs-th sort-key="accountType">Tipo de cuenta</vs-th>
        <vs-th sort-key="currentOwnerName">Nombre cliente</vs-th>
        <vs-th sort-key="currentOwnerDocumentNumber">ID cliente</vs-th>
        <vs-th sort-key="previousOwnerName">Nombre cliente anterior</vs-th>
        <vs-th sort-key="previousOwnerDocumentNumber">ID cliente anterior</vs-th>
        <vs-th sort-key="plate">Matricula</vs-th>
        <vs-th sort-key="antiquity">Antiguedad</vs-th>
        <vs-th sort-key="transferDate">Fecha transferencia</vs-th>
        <vs-th sort-key="segmentLastTransit">Último tránsito</vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr
          :key="indextr"
          v-for="(tr, indextr) in data"
          style="cursor: pointer; text-align: center"
        >
          <vs-td>
            <vs-button
              @click="open_modal(tr)"
              size="small"
              radius
              color="success"
              type="border"
              icon-pack="feather"
              icon="icon-search"
            ></vs-button>
          </vs-td>
          <vs-td
            ><vs-button
              @click="
                note_client = '';
                client_selected = tr;
                getNotes();
              "
              size="small"
              radius
              color="primary"
              type="border"
              icon-pack="feather"
              icon="icon-file"
            ></vs-button
          ></vs-td>
          <td>
            {{ tr.segmentation }}
          </td>
          <td>{{ Math.abs(tr.valorTotal_float) }}</td>
          <td>{{ tr.panapass }}</td>
          <td>{{ tr.accountType }}</td>
          <td>{{ tr.currentOwnerName }}</td>
          <td>{{ tr.currentOwnerDocumentNumber }}</td>
          <td>{{ tr.previousOwnerName }}</td>
          <td>{{ tr.previousOwnerDocumentNumber }}</td>
          <td>{{ tr.plate }}</td>
          <td>{{ tr.antiquity }}</td>
          <td>
            <span v-if="new Date(tr.transferDate) > new Date('2015-01-01')">{{
              tr.transferDate
            }}</span>
            <span v-else style="color: red">{{ tr.transferDate }}</span>
          </td>
          <td>{{ tr.segmentLastTransit }}</td>
        </vs-tr>
      </template>
    </vs-table>
  </div>
</template>
<script>
import axios from "@/axios";
import XLSX from "xlsx";
import { saveAs } from "file-saver";
import traducciones_json from "../../../views/traducciones.json";

export default {
  components: {},
  props: {
    data_query: {
      type: Array,
      required: true,
    },
    total: {
      type: Number,
      required: true,
    },
    search_field1: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      modal_data_query: false,
      modal_upload: false,
      uploading: false,
      detal_selected: [],
      item_selected: [],
      config: null,
      items_table: 5,
      detal_selectedArray: [],
      traducciones: traducciones_json,
      notes_modal: false,
      notes: [],
      client_selected: {},
      note_client: "",
      user_session: {},
    };
  },

  mounted() {
    this.config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.accessToken,
      },
    };

    this.user_session = localStorage.user_session
      ? JSON.parse(localStorage.user_session)
      : {};
  },

  methods: {
    open_modal(item_sel) {
      const traduccionesMap = this.traducciones.reduce((map, traduccion) => {
        map[traduccion.en] = traduccion.es;
        return map;
      }, {});

      if (typeof item_sel === "object" && item_sel !== null) {
        // Convertir el objeto en un array de entradas
        this.detal_selected = Object.entries(item_sel).reduce(
          (nuevoObjeto, [clave, valor]) => {
            const traduccion = traduccionesMap[clave];
            if (traduccion) {
              nuevoObjeto[traduccion] = valor;
            } else {
              nuevoObjeto[clave] = valor;
            }
            return nuevoObjeto;
          },
          {}
        );

        // Convertir el nuevo objeto en un array de entradas para el template
        this.detal_selectedArray = Object.entries(this.detal_selected);
      } else {
        console.error("item_sel no es un objeto o es null:", item_sel);
        this.detal_selected = {};
        this.detal_selectedArray = [];
      }
      this.modal_data_query = true;
      return;
    },
    async upload_file() {
      let me = this;

      if (!document.getElementById("file_client").files[0]) {
        me.$vs.notify({ color: "warn", title: "Seleccione un archivo" });
        return;
      }

      const formData = new FormData();
      formData.append(
        "file_client",
        document.getElementById("file_client").files[0]
      );
      formData.append("panapass", this.search_field1.toUpperCase());

      let config = {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Authorization: "Bearer " + localStorage.accessToken,
        },
      };

      this.uploading = true;
      await axios
        .post(`auth/upload_file_client`, formData, config)
        .then((res) => {
          me.uploading = false;

          if (res.data == 1) {
            me.$emit("get_search");
            me.modal_upload = false;
            me.$vs.notify({
              color: "success",
              title: "Archivo cargado exitosamente",
            });
          } else {
            me.$vs.notify({
              color: "danger",
              title: "Error al cargar archivo",
              text: res.data,
            });
          }
        })
        .catch(function (error) {
          me.uploading = false;
          me.modal_upload = false;
          me.$vs.notify({
            color: "danger",
            title: "Error al cargar archivo",
            text: error,
          });
        });
    },
    exportToXLSX() {
      const XLSX = require("xlsx");
      const dataQuery = this.data_query;

      // Crear una hoja de trabajo a partir de los datos
      const worksheet = XLSX.utils.json_to_sheet(dataQuery);

      // Obtener el rango de encabezados de la hoja de trabajo
      const headerRange = XLSX.utils.decode_range(worksheet["!ref"]);

      // Crear un objeto de traducciones para los encabezados
      const translationMap = this.traducciones.reduce((map, item) => {
        map[item.en] = item.es;
        return map;
      }, {});

      // Reemplazar los encabezados en la hoja de trabajo con las traducciones
      for (let col = headerRange.s.c; col <= headerRange.e.c; col++) {
        const columnHeader = XLSX.utils.encode_col(col) + "1";
        if (worksheet[columnHeader]) {
          // Reemplazar el encabezado con la traducción correspondiente
          const originalHeader = worksheet[columnHeader].v;
          worksheet[columnHeader].v =
            translationMap[originalHeader] || originalHeader;
        }
      }

      // Crear un libro nuevo y agregar la hoja de trabajo
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Datos");

      // Convertir el libro a un buffer y guardar el archivo
      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      const data = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
      });
      saveAs(data, "datos.xlsx");
    },
    async exportToPDF() {
      let me = this;
      let config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.accessToken,
        },
      };
      let api_url = process.env.api.slice(0, -1).replace(/\bapi\b/g, "");
      let data = { data_query: this.data_query, type: "consulta" };
      this.$vs.loading();
      await axios
        .post(`auth/generate_pdf`, data, config)
        .then((res) => {
          me.$vs.loading.close();
          window.open(api_url + res.data.path_document, "_blank");
        })
        .catch(function (error) {
          alert(error);
          me.$vs.loading.close();
        });
    },
    download_format() {
      let api_url = process.env.api.slice(0, -1).replace(/\bapi\b/g, "");
      window.open(api_url + "/documents/formato_valores_ena.csv", "_blank");
    },
    async getNotes() {
      // !this.notes && this.$vs.loading();
      const notes = await axios
        .get(
          `/auth/get_notes_client/${this.client_selected.plate}/${this.client_selected.currentOwnerDocumentNumber}/${this.client_selected.panapass}`
        )
        .then((response) => response.data);
      this.notes = notes;

      // this.notes && me.$vs.loading.close();
      this.notes_modal = true;
    },
    save_note() {
      if (this.note_client) {
        let me = this;
        let data = {
          gnc_note: this.note_client,
          client_plate: this.client_selected.plate,
          currentOwnerDocumentNumber: this.client_selected.currentOwnerDocumentNumber,
          client_panapass: this.client_selected.panapass,
          gestor_name: this.user_session.user_name,
          gestor_id: this.user_session.id,
        };

        if ( (this.client_selected.plate === "0" || this.client_selected.plate === undefined) && (this.client_selected.currentOwnerDocumentNumber === "0" || this.client_selected.currentOwnerDocumentNumber === undefined) && (this.client_selected.panapass === "0" || this.client_selected.panapass === undefined) ) 
        {
          this.$vs.notify({
            title: "Alerta",
            text: "No se puede agregar una nota, el cliente no tiene Número de identificación, Placa o Panapass",
            color: "warning",
            iconPack: "feather",
            icon: "icon-alert-triangle",
            position: "top-center",
          });
          this.notes_modal = false;
          return;
        }
        this.$vs.loading();

        axios
          .post("/auth/save_note_client", data, this.config)
          .then(function (response) {
            me.getNotes();
            me.note_client = "";
            me.$vs.loading.close();
          })
          .catch(function (error) {
            me.$vs.loading.close();
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.input_file_client {
  border: 1px solid rgb(184, 184, 184);
  border-radius: 7px;
  width: 100%;
  padding: 10px 5px 10px 10px;
}
@media (max-width: 990px) {
  .table_header_lg {
    display: none;
  }
  .table_header_sm {
    display: block !important;
  }
}
</style>
